import Button from "../../../Common/Buttons/Button";
import FAQCard from "../../../Common/FAQs/FAQCard";

interface ModalProps {
  onCancel: () => void;
  cancelIcon: string;
}

const FAQComponent = ({ onCancel, cancelIcon }: ModalProps) => {
  const faqs = [
    {
      Title: "What is the Sootchy Education Program (SEP)?",
      Content:
        "The Sootchy Education Program (SEP) is an employer-sponsored 529 higher education savings platform. It enables employees, in collaboration with their employers, to make contributions to a child’s college or other higher education funds and grow savings using a variety of investment options.",
    },
    {
      Title: "Who is eligible to participate in SEP?",
      Content:
        "Employees who are invited by their employer to join SEP can participate. The program is designed to help parents, guardians, and employees save for their children’s education or their own through a 529 savings plan.",
    },
    {
      Title: "How does SEP work?",
      Content:
        "Employees contribute to a 529 account through automated payroll deductions, with the option for employers to match contributions. SEP also allows for additional funding from friends and family Gifting, helping employees save more efficiently.",
    },
    {
      Title: "What are the benefits of SEP?",
      Content: `
        Employer Matching: Employers can match employee contributions, boosting savings potential.

Tax Advantages: Contributions grow tax-deferred, and withdrawals for qualified expenses are tax-free.

Easy Setup: SEP is easy to set up and manage, with online access and automated payroll deductions.
        `,
    },
    {
      Title: "How do I get started with SEP?",
      Content:
        "To get started, you need to receive an invite from your employer. Once you’ve received the invite, you can set up your account online in just a few minutes by entering your personal and beneficiary details.",
    },
    {
      Title: "Can I change my beneficiary?",
      Content:
        "Yes, you can change your beneficiary at any time. You can transfer the funds to another family member if needed.",
    },
    {
      Title: "Can I use SEP funds for anything other than education?",
      Content:
        "SEP funds are intended to be used for qualifying education expenses, including tuition, fees, room and board, and supplies. For non-education expenses, taxes and withdrawal penalties may apply.",
    },
    {
      Title: "Is there a minimum contribution amount?",
      Content:
        "There is no minimum required contribution amount, and contributions can be made through small, consistent payroll deductions, making it easy for employees to save.",
    },
    {
      Title: "Can I contribute to SEP if I don’t have children?",
      Content:
        "Yes, if you are saving for your own education or any other eligible beneficiary, you can participate in the program and start saving for your future.",
    },
  ];

  const faq = faqs.map((item: any) => ({
    title: item.Title,
    content: item.Content,
    open: false,
  }));

  return (
    <>
      <div className="flex justify-between py-[16px] px-[24px] bg-white">
        <h3 className="text-[18px] font-semibold font-outfit">
          Frequently Asked Questions
        </h3>
        <img
          src={cancelIcon}
          onClick={onCancel}
          className="cursor-pointer w-[18px] h-[18px]"
          alt="Close"
        />
      </div>
      <div className="border-y-[1px] border-[#E2E2E2] bg-[#F9F9F9] p-[24px]">
        <FAQCard items={faq} />
      </div>
      <div className="px-[24px] bg-white ">
        <Button
          size="small"
          ariaLabel="previous"
          variant="secondary"
          label="Close"
          iconVisibility="hide"
          handleClick={onCancel}
        />
      </div>
    </>
  );
};

export default FAQComponent;
